export default __webpack_public_path__ + "static/media/cut here.6ecc574f.png";